import parse from 'html-react-parser';

import { formatMessageWithCitations } from '../../lib/citation';
import type { HeySynclyAnswer } from '../../model';
import { CollapsibleReason } from './collapsible-reason';
import { MessageTextStyle } from './message-text-style';
import { StatusDisplay } from './status-display';
import { StudioItemPreview } from './studio-item-preview';
import { useParseOptions } from './use-parse-options';

export const TempAnswerDisplay = (props: { answer: HeySynclyAnswer }) => {
  const { answer } = props;
  const { options: parseOptions } = useParseOptions({
    chatAlias: answer.chat_alias,
    clickEnabled: false,
  });
  const formattedMessage = formatMessageWithCitations({
    text: answer.answer,
    message_id: 'temp-answer',
  });

  return (
    <div className="flex flex-col gap-2">
      <StatusDisplay status={answer.status} />
      {answer.reason && (
        <CollapsibleReason initialOpen={true} isLoading={true}>
          {parse(
            formatMessageWithCitations({
              text: answer.reason,
              message_id: `temp-reason`, //dummy
              hideCitation: true,
            }),
            parseOptions,
          )}
        </CollapsibleReason>
      )}
      {!answer.item && (
        <MessageTextStyle className="p-2 rounded-3xl min-h-[calc(100vh-430px)]">
          {parse(formattedMessage, parseOptions)}
        </MessageTextStyle>
      )}

      {answer.item && (
        <div className="flex flex-col gap-5 px-2 min-h-[calc(100vh-555px)]">
          <span className="text-xs font-medium text-muted-foreground">
            This may take a few minutes.
          </span>
          <StudioItemPreview item={answer.item} onClick={() => {}} />
        </div>
      )}
      {/* 
      <div
        className={cn([
          'h-[calc(100vh-430px)]',
          {
            'h-[calc(100vh-555px)]': !!answer.item,
          },
        ])}
      /> */}
    </div>
  );
};
